/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createClient = /* GraphQL */ `mutation CreateClient(
  $input: CreateClientInput!
  $condition: ModelClientConditionInput
) {
  createClient(input: $input, condition: $condition) {
    id
    ownerUserId
    name
    slug
    inviteLink
    userRole
    defaultWorkspaces
    meta
    created_at
    customer_id
    subscription_plan
    subscription_status
    subscription_endsAt
    subscription_details
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateClientMutationVariables,
  APITypes.CreateClientMutation
>;
export const updateClient = /* GraphQL */ `mutation UpdateClient(
  $input: UpdateClientInput!
  $condition: ModelClientConditionInput
) {
  updateClient(input: $input, condition: $condition) {
    id
    ownerUserId
    name
    slug
    inviteLink
    userRole
    defaultWorkspaces
    meta
    created_at
    customer_id
    subscription_plan
    subscription_status
    subscription_endsAt
    subscription_details
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateClientMutationVariables,
  APITypes.UpdateClientMutation
>;
export const deleteClient = /* GraphQL */ `mutation DeleteClient(
  $input: DeleteClientInput!
  $condition: ModelClientConditionInput
) {
  deleteClient(input: $input, condition: $condition) {
    id
    ownerUserId
    name
    slug
    inviteLink
    userRole
    defaultWorkspaces
    meta
    created_at
    customer_id
    subscription_plan
    subscription_status
    subscription_endsAt
    subscription_details
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteClientMutationVariables,
  APITypes.DeleteClientMutation
>;
export const createClientUser = /* GraphQL */ `mutation CreateClientUser(
  $input: CreateClientUserInput!
  $condition: ModelClientUserConditionInput
) {
  createClientUser(input: $input, condition: $condition) {
    ownerId
    id
    email
    sub
    name
    surname
    isAdmin
    isReadOnly
    roles
    roleUpdatedBy
    isConfirmed
    avatarPath
    closedAt
    lastActive
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateClientUserMutationVariables,
  APITypes.CreateClientUserMutation
>;
export const updateClientUser = /* GraphQL */ `mutation UpdateClientUser(
  $input: UpdateClientUserInput!
  $condition: ModelClientUserConditionInput
) {
  updateClientUser(input: $input, condition: $condition) {
    ownerId
    id
    email
    sub
    name
    surname
    isAdmin
    isReadOnly
    roles
    roleUpdatedBy
    isConfirmed
    avatarPath
    closedAt
    lastActive
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateClientUserMutationVariables,
  APITypes.UpdateClientUserMutation
>;
export const deleteClientUser = /* GraphQL */ `mutation DeleteClientUser(
  $input: DeleteClientUserInput!
  $condition: ModelClientUserConditionInput
) {
  deleteClientUser(input: $input, condition: $condition) {
    ownerId
    id
    email
    sub
    name
    surname
    isAdmin
    isReadOnly
    roles
    roleUpdatedBy
    isConfirmed
    avatarPath
    closedAt
    lastActive
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteClientUserMutationVariables,
  APITypes.DeleteClientUserMutation
>;
export const createClientUserInvite = /* GraphQL */ `mutation CreateClientUserInvite(
  $input: CreateClientUserInviteInput!
  $condition: ModelClientUserInviteConditionInput
) {
  createClientUserInvite(input: $input, condition: $condition) {
    ownerId
    id
    email
    isAdmin
    isReadOnly
    roles
    isInviteConfirmed
    inviteLink
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateClientUserInviteMutationVariables,
  APITypes.CreateClientUserInviteMutation
>;
export const updateClientUserInvite = /* GraphQL */ `mutation UpdateClientUserInvite(
  $input: UpdateClientUserInviteInput!
  $condition: ModelClientUserInviteConditionInput
) {
  updateClientUserInvite(input: $input, condition: $condition) {
    ownerId
    id
    email
    isAdmin
    isReadOnly
    roles
    isInviteConfirmed
    inviteLink
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateClientUserInviteMutationVariables,
  APITypes.UpdateClientUserInviteMutation
>;
export const deleteClientUserInvite = /* GraphQL */ `mutation DeleteClientUserInvite(
  $input: DeleteClientUserInviteInput!
  $condition: ModelClientUserInviteConditionInput
) {
  deleteClientUserInvite(input: $input, condition: $condition) {
    ownerId
    id
    email
    isAdmin
    isReadOnly
    roles
    isInviteConfirmed
    inviteLink
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteClientUserInviteMutationVariables,
  APITypes.DeleteClientUserInviteMutation
>;
export const createWorkspace = /* GraphQL */ `mutation CreateWorkspace(
  $input: CreateWorkspaceInput!
  $condition: ModelWorkspaceConditionInput
) {
  createWorkspace(input: $input, condition: $condition) {
    ownerId
    id
    name
    slug
    avatarPath
    childIds
    archivedIds
    trashedIds
    pinnedIds
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWorkspaceMutationVariables,
  APITypes.CreateWorkspaceMutation
>;
export const updateWorkspace = /* GraphQL */ `mutation UpdateWorkspace(
  $input: UpdateWorkspaceInput!
  $condition: ModelWorkspaceConditionInput
) {
  updateWorkspace(input: $input, condition: $condition) {
    ownerId
    id
    name
    slug
    avatarPath
    childIds
    archivedIds
    trashedIds
    pinnedIds
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWorkspaceMutationVariables,
  APITypes.UpdateWorkspaceMutation
>;
export const deleteWorkspace = /* GraphQL */ `mutation DeleteWorkspace(
  $input: DeleteWorkspaceInput!
  $condition: ModelWorkspaceConditionInput
) {
  deleteWorkspace(input: $input, condition: $condition) {
    ownerId
    id
    name
    slug
    avatarPath
    childIds
    archivedIds
    trashedIds
    pinnedIds
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWorkspaceMutationVariables,
  APITypes.DeleteWorkspaceMutation
>;
export const createWorkspaceUser = /* GraphQL */ `mutation CreateWorkspaceUser(
  $input: CreateWorkspaceUserInput!
  $condition: ModelWorkspaceUserConditionInput
) {
  createWorkspaceUser(input: $input, condition: $condition) {
    ownerId
    workspaceId
    userId
    role
    createdAt
    updatedAt
    createdBy
    updatedBy
    id
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWorkspaceUserMutationVariables,
  APITypes.CreateWorkspaceUserMutation
>;
export const updateWorkspaceUser = /* GraphQL */ `mutation UpdateWorkspaceUser(
  $input: UpdateWorkspaceUserInput!
  $condition: ModelWorkspaceUserConditionInput
) {
  updateWorkspaceUser(input: $input, condition: $condition) {
    ownerId
    workspaceId
    userId
    role
    createdAt
    updatedAt
    createdBy
    updatedBy
    id
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWorkspaceUserMutationVariables,
  APITypes.UpdateWorkspaceUserMutation
>;
export const deleteWorkspaceUser = /* GraphQL */ `mutation DeleteWorkspaceUser(
  $input: DeleteWorkspaceUserInput!
  $condition: ModelWorkspaceUserConditionInput
) {
  deleteWorkspaceUser(input: $input, condition: $condition) {
    ownerId
    workspaceId
    userId
    role
    createdAt
    updatedAt
    createdBy
    updatedBy
    id
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWorkspaceUserMutationVariables,
  APITypes.DeleteWorkspaceUserMutation
>;
export const createItem = /* GraphQL */ `mutation CreateItem(
  $input: CreateItemInput!
  $condition: ModelItemConditionInput
) {
  createItem(input: $input, condition: $condition) {
    ownerId
    workspaceId
    id
    name
    type
    childIds
    parentIds
    readRoles
    writeRoles
    creator
    pinned
    trashed
    archived
    statusUpdatedBy
    ackUpdatedBy
    acknowledgementRequired
    acknowledgement
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateItemMutationVariables,
  APITypes.CreateItemMutation
>;
export const updateItem = /* GraphQL */ `mutation UpdateItem(
  $input: UpdateItemInput!
  $condition: ModelItemConditionInput
) {
  updateItem(input: $input, condition: $condition) {
    ownerId
    workspaceId
    id
    name
    type
    childIds
    parentIds
    readRoles
    writeRoles
    creator
    pinned
    trashed
    archived
    statusUpdatedBy
    ackUpdatedBy
    acknowledgementRequired
    acknowledgement
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateItemMutationVariables,
  APITypes.UpdateItemMutation
>;
export const deleteItem = /* GraphQL */ `mutation DeleteItem(
  $input: DeleteItemInput!
  $condition: ModelItemConditionInput
) {
  deleteItem(input: $input, condition: $condition) {
    ownerId
    workspaceId
    id
    name
    type
    childIds
    parentIds
    readRoles
    writeRoles
    creator
    pinned
    trashed
    archived
    statusUpdatedBy
    ackUpdatedBy
    acknowledgementRequired
    acknowledgement
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteItemMutationVariables,
  APITypes.DeleteItemMutation
>;
export const createEvent = /* GraphQL */ `mutation CreateEvent(
  $input: CreateEventInput!
  $condition: ModelEventConditionInput
) {
  createEvent(input: $input, condition: $condition) {
    id
    ownerId
    workspaceId
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEventMutationVariables,
  APITypes.CreateEventMutation
>;
export const updateEvent = /* GraphQL */ `mutation UpdateEvent(
  $input: UpdateEventInput!
  $condition: ModelEventConditionInput
) {
  updateEvent(input: $input, condition: $condition) {
    id
    ownerId
    workspaceId
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEventMutationVariables,
  APITypes.UpdateEventMutation
>;
export const deleteEvent = /* GraphQL */ `mutation DeleteEvent(
  $input: DeleteEventInput!
  $condition: ModelEventConditionInput
) {
  deleteEvent(input: $input, condition: $condition) {
    id
    ownerId
    workspaceId
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEventMutationVariables,
  APITypes.DeleteEventMutation
>;
export const createNotification = /* GraphQL */ `mutation CreateNotification(
  $input: CreateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  createNotification(input: $input, condition: $condition) {
    id
    ownerId
    userId
    eventId
    status
    channelAttempts
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNotificationMutationVariables,
  APITypes.CreateNotificationMutation
>;
export const updateNotification = /* GraphQL */ `mutation UpdateNotification(
  $input: UpdateNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  updateNotification(input: $input, condition: $condition) {
    id
    ownerId
    userId
    eventId
    status
    channelAttempts
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNotificationMutationVariables,
  APITypes.UpdateNotificationMutation
>;
export const deleteNotification = /* GraphQL */ `mutation DeleteNotification(
  $input: DeleteNotificationInput!
  $condition: ModelNotificationConditionInput
) {
  deleteNotification(input: $input, condition: $condition) {
    id
    ownerId
    userId
    eventId
    status
    channelAttempts
    initiatorId
    type
    meta
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNotificationMutationVariables,
  APITypes.DeleteNotificationMutation
>;
export const createDocument = /* GraphQL */ `mutation CreateDocument(
  $input: CreateDocumentInput!
  $condition: ModelDocumentConditionInput
) {
  createDocument(input: $input, condition: $condition) {
    ownerId
    id
    docVersion
    content
    latestEditor
    trashed
    archived
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDocumentMutationVariables,
  APITypes.CreateDocumentMutation
>;
export const updateDocument = /* GraphQL */ `mutation UpdateDocument(
  $input: UpdateDocumentInput!
  $condition: ModelDocumentConditionInput
) {
  updateDocument(input: $input, condition: $condition) {
    ownerId
    id
    docVersion
    content
    latestEditor
    trashed
    archived
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDocumentMutationVariables,
  APITypes.UpdateDocumentMutation
>;
export const deleteDocument = /* GraphQL */ `mutation DeleteDocument(
  $input: DeleteDocumentInput!
  $condition: ModelDocumentConditionInput
) {
  deleteDocument(input: $input, condition: $condition) {
    ownerId
    id
    docVersion
    content
    latestEditor
    trashed
    archived
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDocumentMutationVariables,
  APITypes.DeleteDocumentMutation
>;
